import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { resolveWeightUnit, weightFactor } from '@/utils/weight';

/** Unidad de peso de la organización (kg o lb). Los datos se guardan en kg; aquí solo se convierten para mostrarlos. */
export function useWeightUnit() {
  const { user } = useAuth();
  const unit = resolveWeightUnit(user?.organization?.weight_unit);

  return useMemo(() => {
    const factor = weightFactor(unit);
    return {
      unit,
      factor,
      /** De kg (como se guarda) a la unidad de la organización. */
      fromKg: (kg: number) => kg * factor,
      /** De la unidad de la organización a kg (para guardar). */
      toKg: (value: number) => value / factor,
    };
  }, [unit]);
}
